import Header from './Headers';
import Const from '../util/Constants';
import Config from '../config/config';

class ModuleAPI {

  static get = (id, success, failure) => {
    fetch(Config.app.link + 'api/document_type/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static save = (module, success, failure) => {
    fetch(Config.app.link + 'api/document_type', new Header('POST', module))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static delete = (fieldId, success, failure) => {
    fetch(`${Config.app.link}api/document_type/delete/${fieldId}`, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static list = (success, failure) => {
    fetch(`${Config.app.link}api/document_type`, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
}

export default ModuleAPI;